import { IApplicationState } from '../../../types/redux';
import { ISpecialist } from '../../../types/specialist';

export const selectRealtorsData = (state: IApplicationState): ISpecialist[] => {
  return state.mainpage.realtors;
};
